import styled from 'styled-components';

import { flexAsColumn, flexAsRow } from '@components/Styled/mixins';

const getAlertColor = (alertType, theme) => {
  const colorPalette = alertType === 'WARNING'
    ? theme.colors.support.warning
    : theme.colors.support.info;

  return colorPalette[400];
};

const AlertWrapper = styled.div`
  ${flexAsColumn(1)};

  width: 100%;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ alertType, theme }) => getAlertColor(alertType, theme)};
  color: ${({ alertType, theme }) => getAlertColor(alertType, theme)};
`;

const InfoWrapper = styled.div`
  ${flexAsRow(2)};

  justify-content: center;
  align-items: center;
`;

export { AlertWrapper, InfoWrapper };
